export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5599.0c8bf80d.jpg";